import {
  Component,
  Inject
} from 'ng-metadata/core';

import menuBarHtml from './menu-bar.html'
import './menu-bar.scss'

/**
 * Search Component
 */
@Component({
  selector: 'gwMenuBar',
  template: menuBarHtml
})

export class MenuBarComponent {
  public isOpen: boolean = false

  constructor(
     @Inject('$scope') private $scope: ng.IScope,
     @Inject('$element') private $element: ng.IRootElementService,
     @Inject('$rootScope') private $rootScope: ng.IRootScopeService,
  ) {}

  handleClick(e: Event) {
    this.isOpen = !this.isOpen
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/common/menu-bar/menu-bar.component.ts